import { Box, IconButton, Typography } from "@material-ui/core"
import { BlessingResponse } from "api"
import { useIsDesktop } from "common/MediaQueries"
import Image from "next/image"
import { useRouter } from "next/router"
import styled from "styled-components"
import BackIcon from "../../../Icons/BackIcon"

const StyledTitle = styled(Typography).attrs({ variant: "h1" })`
  font-weight: bold;
  font-size: 50px;
  line-height: 40px;
  text-align: right;
  font-family: NarkisBlock;
  margin-top: 40px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-top: 20px;
  }
`

const StyledSubtitle = styled(Typography).attrs({ variant: "body1" })`
  font-size: 20px;
  line-height: 26px;
  text-align: right;
  margin-top: 10px;
  font-weight: 400;
  font-family: "NarkisBlock-Thin";
`

const StyledLink = styled.div`
  display: flex;
  cursor: pointer;
  padding-top: 40px;
  p {
    margin-right: 8px;
  }
  :hover {
    text-decoration: underline;
  }
`

const StyledIconBtn = styled(IconButton)`
  padding: 1px;
  position: relative;
  bottom: 2px;
`

const StyledImageWrapper = styled(Box)`
  order: 1;
  img {
    border-radius: 20px;
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-top: 20px;
    margin-bottom: 20px;
  }
`

const StyledInnerWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-direction: column;
    align-items: flex-start;
  }
`

const StyledTextWrapper = styled(Box)``

type PaymentHeaderProps = {
  title: string
  subtitle: string
  giftCard?: BlessingResponse
}

const PaymentHeader = ({ title, subtitle, giftCard }: PaymentHeaderProps) => {
  const router = useRouter()
  const isDesktop = useIsDesktop()
  return (
    <>
      <StyledLink onClick={() => router.back()}>
        <StyledIconBtn>
          <BackIcon />
        </StyledIconBtn>
        <Typography variant="body1">חזרה</Typography>
      </StyledLink>
      <StyledInnerWrapper>
        {giftCard && (
          <StyledImageWrapper>
            <Image
              src={giftCard?.image?.imageUrl || "/"}
              alt={giftCard?.image?.alt}
              width={isDesktop ? "404px" : "188px"}
              height={isDesktop ? "266px" : "136px"}
            />
          </StyledImageWrapper>
        )}

        <StyledTextWrapper>
          <StyledTitle>{title}</StyledTitle>
          <StyledSubtitle>{subtitle}</StyledSubtitle>
        </StyledTextWrapper>
      </StyledInnerWrapper>
    </>
  )
}

export default PaymentHeader
